import { decodeBase64, encodeBase64 } from '../utils';

export function encodeBase64Urlsafe(data: Uint8Array | ArrayBuffer) {
  return encodeBase64(data instanceof Uint8Array ? data : new Uint8Array(data))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/g, '');
}

export function decodeBase64Urlsafe(data: string): Uint8Array<ArrayBuffer> {
  const substituted = data.replace(/_/g, '/').replace(/-/g, '+');
  const padLength = (4 - (substituted.length % 4)) % 4;
  const padded = substituted.padEnd(substituted.length + padLength, '=');
  return decodeBase64(padded);
}
